import type { LandingStrings } from './en';

export const ko: LandingStrings = {
  header: {
    brandSubtitle: '마법 가게',
    contact: '문의',
    about: '게임 소개',
    language: '언어',
  },
  footer: {
    terms: '이용약관',
    privacy: '개인정보처리방침',
    copyright: '{year} {holder}. 모든 권리 보유.',
  },
  home: {
    heroTitle: '포션과 마법 가게를 담은 아늑한 3D 게임.',
    heroDescription:
      '마법 잡동사니 속에서 재료를 찾고, 가마솥에서 포션을 끓여 나만의 가게에서 팔아 봐요.',
    features: [
      {
        title: '나만의 포션 병',
        desc: '모양, 뚜껑, 포션 색까지. 예쁜 병일수록 더 비싸게 팔려요.',
      },
      {
        title: '의미 있는 조제',
        desc: '포션마다 레시피가 따로 있고, 그중 많은 포션이 게임 속에서 정말로 효과를 내요.',
      },
      {
        title: '다음이 궁금한 이야기',
        desc: '할머니가 휴가를 떠나시면서 가게를 맡기셨는데, 모렌이라는 개구리가 제 몫을 내놓으라고 해요.',
      },
      {
        title: '진짜 내 가게',
        desc: '가게에서는 내 손으로 조제한 것만 팔 수 있어요.',
      },
    ],
    appStore: 'App Store',
    googlePlay: 'Google Play',
    comingSoon: '곧 출시',
    tags: { search: '그림자로 재료 찾기', craft: '3D 포션 조제', shop: '아늑한 가게' },
  },
  about: {
    title: 'Qevryno 소개',
    intro: [
      'Qevryno에 온 걸 환영해요! 마법을 손으로 하나하나 빚어 가는 아늑한 포션 조제 게임이에요.',
      '할머니가 휴가를 떠나시면서 신비로운 옛집을 봐 달라고 부탁하셨어요. 잊힌 레시피와 마법 재료, 그리고 아직도 보글보글 끓는 법을 기억하는 가마솥이 있는 집이에요. 아래층에는 작은 가게가 있는데, 마을 사람들은 벌써 누가 가게를 맡았는지 궁금해하고 있어요.',
      '포션을 조제하고, 복슬복슬한 사역마를 돌보고, 내가 만든 것들을 매력 넘치는 손님들에게 팔고, 코인을 모아 마법의 집을 꾸며 봐요. 타이머에 쫓기지 않고, 내 속도대로요.',
    ],
    whatTitle: '어떤 게임인가요?',
    what: [
      'Qevryno는 숨은그림찾기, 연금술 조제, 작은 가게 경영 시뮬레이션이 어우러진 편안한 3D 퍼즐 게임이에요. 아늑한 힐링 게임, 캐주얼 퍼즐 게임, 숨은그림찾기 게임, 포션(물약)과 연금술 게임, 나만의 마법 가게를 꾸리는 게임을 좋아한다면 바로 이 게임이에요.',
      '혼자 즐기는 게임이고, 인터넷 없이도 할 수 있어요. 인터넷은 구매와, 원할 때만 보는 보상 영상에만 필요해요. 배너 광고나 팝업 광고는 없어요. 보너스를 주는 Google AdMob의 짧은 영상은 내가 누를 때만 재생돼요. 선택 구매 상품은 보석과, 구성이 미리 보이는 재료 꾸러미예요. 곧 iOS와 Android로 출시될 예정이고, 한국어, 영어, 러시아어, 스페인어, 독일어, 프랑스어, 네덜란드어, 이탈리아어, 포르투갈어(브라질), 폴란드어, 일본어, 중국어(번체), 튀르키예어를 지원해요.',
    ],
    doTitle: '이런 걸 할 수 있어요',
    doList: [
      '마법이 깃든 3D 숲속 빈터에서 숨은 재료를 찾아요. 빈터마다 작은 디오라마 같아요.',
      '가마솥에서 마법 레시피를 조제해요. 안정제, 주재료, 시간의 허브, 그리고 색 한 방울.',
      '나만의 포션 병을 디자인해요. 모양, 뚜껑, 포션 색까지 — 예쁜 병일수록 더 비싸게 팔려요.',
      '내 가게를 운영해요. 손님, 평판, 장날, 퀘스트까지.',
      '이야기를 따라가요. 할머니는 휴가를 떠나시면서 가게를 맡기셨는데, 모렌이라는 개구리가 자꾸만 제 몫을 내놓으라고 해요.',
      '찾아낸 재료를 절구에 빻고, 믹싱 볼에서 섞고, 반짝이를 더해요. 혼합물마다 질감과 색이 달라요.',
      '사역마에게 밥을 주고 가게를 꾸며요.',
    ],
    faqTitle: '자주 묻는 질문',
    faq: [
      { q: 'Qevryno는 무료인가요?', a: '네. 게임은 무료이고, 결제하지 않아도 즐길 수 있어요. 선택 구매 상품으로는 보석과 재료 꾸러미가 있어요.' },
      { q: '인터넷 없이도 할 수 있나요?', a: '네. 게임 자체는 인터넷이 필요 없어요. 비행기 안에서도, 담요를 둘러쓰고도 포션을 조제해 봐요. 인터넷은 구매와, 원할 때만 보는 보상 영상에만 필요해요.' },
      { q: '광고가 있나요?', a: '원할 때만 보는 광고만 있어요. 배너 광고나 화면 사이에 뜨는 팝업 광고는 없어요. 몇몇 곳에서 원하면 짧은 영상을 보고 마나 같은 보너스를 받을 수 있어요. 게임 안에서 영상을 꼭 봐야 하는 곳은 없어요. 영상은 Google AdMob이 제공해요. 자세한 내용은 개인정보처리방침에서 확인해 주세요.' },
      { q: '어떤 플랫폼에서 나오나요?', a: 'iOS와 Android예요. 한국어, 영어, 러시아어, 스페인어, 독일어, 프랑스어, 네덜란드어, 이탈리아어, 포르투갈어(브라질), 폴란드어, 일본어, 중국어(번체), 튀르키예어를 지원해요.' },
      { q: '무섭거나 긴장되는 게임인가요?', a: '전혀요. 잔잔한 음악이 흐르는 편안하고 아늑한 게임이에요. 실수해도 벌칙이 없고, 모자 쓴 고양이도 있어요.' },
    ],
  },
  contact: {
    title: '문의하기',
    subtitle: 'Qevryno에 대해 궁금한 점이나 오류, 구매나 광고 문제가 있나요? 이메일로 보내 주세요.',
    write: '이메일 보내기',
    mailSubject: 'Qevryno: 고객 지원',
    tip: '사용 중인 기기와 어떤 일이 있었는지 적어 주시면 더 쉽게 도와드릴 수 있어요.',
    info: {
      title: '연락처',
      email: '이메일',
      security: '보안',
      legalName: '개발자',
      address: '주소',
    },
    refunds: {
      title: '환불 및 구매',
      description: '모든 구매는 Apple App Store 또는 Google Play를 통해 이루어져요. 환불을 원하시면 스토어에 문의해 주세요:',
      apple: 'Apple App Store',
      appleUrl: 'https://support.apple.com/ko-kr/HT204084',
      google: 'Google Play',
      googleUrl: 'https://support.google.com/googleplay/answer/2479637?hl=ko',
      link: '환불 요청하기',
      note: '저희는 결제를 직접 받지 않아서 환불해 드릴 수 없어요. 구매한 항목이 게임에 들어오지 않았다면 「설정 → 구매 복원」을 열거나 저희에게 이메일을 보내 주세요.',
    },
  },
  legal: {
    dataController: '개인정보처리자',
    // Политика и условия есть на английском, русском и испанском; для остальных языков страница показывает английский текст и эту строку
    onlyIn: '이 문서는 영어, 러시아어, 스페인어로만 제공됩니다. 아래는 영어판입니다.',
  },
};
